module.exports = __webpack_public_path__ + "static/media/raduno1970.6c3edbec.jpg";